import script from "./ConfirmMaterialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmMaterialDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmMaterialDialog.vue?vue&type=style&index=0&id=1b0f0869&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0f0869"]])

export default __exports__